module.exports = __webpack_public_path__ + "img/Monte_Kope_124.d190df2d.jpg";